/* Petal Post: date, time window and mobile number on product pages.
   Delivery or pickup is chosen ONCE, at checkout (Ship or Pick up), so the two can never disagree.
   Saves to the cart as order attributes so they appear on every order in Shopify admin:
   Delivery or pickup date, Pickup or delivery time window, Your phone number, Delivery notes.
   Online cut-off: book by 8pm Sydney time for next-day. Same-day is by phone or text only, by 8am. */
(function () {
  var root = document.getElementById('petal-options');
  var box = root && root.querySelector('.pp-box');
  if (!box || document.getElementById('pp-date')) return;

  var KEY = 'Delivery or pickup date';
  var TIME_KEY = 'Pickup or delivery time window';
  var PHONE_KEY = 'Your phone number';
  var PHONE = '0418 859 997';
  var CUTOFF_HOUR = 20;
  var isSub = false;
  try { isSub = JSON.parse(root.querySelector('script[data-pp-data]').textContent).type === 'Subscription'; } catch (e) {}

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function sydneyNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { y: parseInt(o.year, 10), m: parseInt(o.month, 10), d: parseInt(o.day, 10), h: parseInt(o.hour, 10) % 24 };
    } catch (e) { var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() }; }
  }
  function addDays(s, n) { var t = new Date(Date.UTC(s.y, s.m - 1, s.d + n)); return t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()); }
  var now = sydneyNow();
  var late = now.h >= CUTOFF_HOUR;
  var minDate = addDays(now, late ? 2 : 1);
  function nice(v) { var d = new Date(v + 'T00:00:00'); return d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }

  var lateNote = late ? '<p class="pp-note">It is past our 8pm online cut-off for tomorrow, so the earliest date online is ' + nice(minDate) + '. Need tomorrow? Call or text <a href="tel:+61418859997">' + PHONE + '</a> and we will do our best.</p>' : '';

  var html =
    '<div class="pp-date" id="pp-date">' +
      '<label class="pp-label" for="pp-date-input" style="display:block">' + (isSub ? 'First delivery or pickup date' : 'Delivery or pickup date') + '</label>' +
      '<input type="date" id="pp-date-input" min="' + minDate + '" required>' +
      '<p class="pp-note">Book online by 8pm for next-day. Need it today? Call or text <a href="tel:+61418859997">' + PHONE + '</a> before 8am and we will do our best.</p>' +
      lateNote +
      '<label class="pp-label" for="pp-time-input" style="margin-top:1rem;display:block">Time window</label>' +
      '<select id="pp-time-input" required>' +
        '<option value="">Choose a time window</option>' +
        '<option>8am to 10am</option><option>10am to 12pm</option><option>12pm to 2pm</option><option>2pm to 4pm</option><option>4pm to 6pm</option><option>6pm to 7pm</option>' +
      '</select>' +
      '<label class="pp-label" for="pp-phone" style="margin-top:1rem;display:block">Your mobile number</label>' +
      '<input type="tel" id="pp-phone" maxlength="20" placeholder="So we can reach you about your order" autocomplete="tel">' +
      '<label class="pp-label" for="pp-dnotes" style="margin-top:1rem;display:block">Delivery notes <em style="font-style:normal;opacity:.65">(optional)</em></label>' +
      '<input type="text" id="pp-dnotes" maxlength="160" placeholder="Gate code, where to leave it if no one is home" autocomplete="off">' +
      '<p class="pp-note">At checkout you choose <strong>Ship</strong> (we deliver) or <strong>Pick up</strong> (free, from Canada Bay).</p>' +
      '<p class="pp-error" id="pp-date-error" role="alert" hidden></p>' +
    '</div>';
  var css = '.pp-date{margin:0.4rem 0 1.4rem;padding-bottom:1.4rem;border-bottom:1px solid rgba(var(--color-foreground),0.12)}' +
    '.pp-date input[type=date],.pp-date input[type=text],.pp-date input[type=tel],.pp-date select{display:block;width:100%;margin-top:0.4rem;padding:0.9rem 1.1rem;font:inherit;border:1px solid rgba(var(--color-foreground),0.35);border-radius:2px;background:transparent;color:inherit;box-sizing:border-box}' +
    '.pp-date a{text-decoration:underline}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var legend = box.querySelector('.pp-title');
  if (legend) legend.insertAdjacentHTML('afterend', html); else box.insertAdjacentHTML('afterbegin', html);

  var input = document.getElementById('pp-date-input');
  var timeSel = document.getElementById('pp-time-input');
  var phoneIn = document.getElementById('pp-phone');
  var dnotes = document.getElementById('pp-dnotes');
  var err = document.getElementById('pp-date-error');

  function phoneOk() { return phoneIn.value.replace(/[^0-9]/g, '').length >= 8; }
  try {
    var saved = localStorage.getItem('pp-date'); if (saved && saved >= minDate) input.value = saved;
    var savedT = localStorage.getItem('pp-time'); if (savedT) timeSel.value = savedT;
    var savedP = localStorage.getItem('pp-phone'); if (savedP) phoneIn.value = savedP;
  } catch (e) {}

  function check(showEmpty) {
    var v = input.value;
    var msg = '';
    if (!v) msg = showEmpty ? 'Please choose your date.' : '';
    else if (v < minDate) msg = 'Online orders close at 8pm the day before. For anything sooner, please call or text ' + PHONE + '.';
    else if (showEmpty && !timeSel.value) msg = 'Please choose a time window.';
    else if (showEmpty && !phoneOk()) msg = 'Please add your mobile number so we can reach you about this order.';
    err.textContent = msg; err.hidden = !msg;
    return !msg && !!v;
  }
  input.addEventListener('change', function () {
    check(false);
    try { if (input.value) localStorage.setItem('pp-date', input.value); } catch (e) {}
  });
  timeSel.addEventListener('change', function () { err.hidden = true; try { localStorage.setItem('pp-time', timeSel.value); } catch (e) {} });
  phoneIn.addEventListener('change', function () { err.hidden = true; try { localStorage.setItem('pp-phone', phoneIn.value.trim()); } catch (e) {} });

  function saveToCart(v) {
    var attrs = {};
    attrs[KEY] = nice(v) + ' (' + v + ')';
    attrs[TIME_KEY] = timeSel.value;
    attrs[PHONE_KEY] = phoneIn.value.trim();
    attrs['Delivery notes'] = dnotes.value.trim();
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  // Runs before the add-to-cart handlers (window capture fires before document capture).
  window.addEventListener('submit', function (e) {
    var fm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!fm || e.target !== fm) return;
    var req = document.getElementById('pp-req-flowers');
    if (req && req.value.trim()) return; // quote request, no cart
    if (!check(true)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var target = !input.value ? input : (!timeSel.value ? timeSel : phoneIn);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (target.focus) target.focus();
      return;
    }
    window.__ppDateSaved = saveToCart(input.value);
  }, true);
})();
